import { useEffect, useState } from 'react';
import { ContactSupportId } from 'src/constants/constants';
import getEnv from 'src/env/enviroment';
import { ScriptStatus, useScript } from 'src/helpers/hooks';

interface CovieWidgetProps {
  onInit?: (a: any) => void;
  onSuccess?: (a: any) => void;
  onError?: (a: any, b: any) => void;
  onStepChange?: (a: any) => void;
  onDocumentUpload?: (a: any) => void;
  metaData?: { [key: string]: any };
  activeCovieLink?: string | null;
}

export const CovieWidget = ({
  onInit,
  onSuccess,
  onError,
  onStepChange,
  onDocumentUpload,
  metaData,
  activeCovieLink,
}: CovieWidgetProps) => {
  const covieScriptStatus = useScript(
    'https://access.covie.io/sdk/covie-access.js',
  );
  const [error, setError] = useState('');

  useEffect(() => {
    if (covieScriptStatus === ScriptStatus.ERROR) {
      setError('Error while script loading');
    }
  }, [covieScriptStatus]);

  useEffect(() => {
    if (
      covieScriptStatus === ScriptStatus.READY &&
      (window as any).CovieAccess &&
      !error
    ) {
      (window as any).CovieAccess.init({
        elementId: 'covie-root',
        integrationKey: getEnv().covie_secret,
        linkId: activeCovieLink,
        width: '100%',
        height: '700',
        linkMetadata: metaData,
        onInit: function (linkId: any) {
          if (linkId) {
            onInit && onInit(linkId);
          }
        },
        onSuccess: function (linkId: any, embedPolicies: any) {
          if (Array.isArray(embedPolicies) && embedPolicies.length) {
            onSuccess && onSuccess(embedPolicies[0]);
          }
        },
        onDocumentUpload: function (linkId: any, link: string) {
          onDocumentUpload && onDocumentUpload(link);
        },
        onStepChange: function (linkId: any, step: any) {
          onStepChange && onStepChange(step);
        },
        onLinkError: function (linkId: any, error: any) {
          onError && onError(linkId, error);
        },
        hide: [],
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [covieScriptStatus, error, onError, onStepChange, onSuccess]);

  return (
    <div className="w-100">
      <div id="covie-root" style={{ height: 700 }}></div>
      {!!error &&
        `We are having some trouble, Please contact support for help. id: ${ContactSupportId.covie}`}
    </div>
  );
};

export default CovieWidget;
